"use client";

import { clubApi, getQueryClient } from "@onsand/api";
import { SessionProvider } from "@onsand/auth";
import { QueryClientProvider } from "@tanstack/react-query";

export function Providers({ children }: { children: React.ReactNode }) {
	const queryClient = getQueryClient();

	return (
		<QueryClientProvider client={queryClient}>
			<SessionProvider queryFn={() => clubApi.session.me()}>{children}</SessionProvider>
		</QueryClientProvider>
	);
}
